export default function compactObject(obj) {
  let newObj = {};
  Object.keys(obj).forEach(prop => {
    if (obj[prop] || typeof obj[prop] === 'boolean') {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
}
